/**
 *
 * FormField
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { FormField } from '../FormFields';
import { Button } from '../Buttons';
import { BaseComponent } from '../BaseComponent';

export const Input = styled.input`
  outline: none;
`;

//
//this.formRef = React.createRef();

//ref={this.formRef} fields={KABOOM_LC_REQUEST_FIELDS} />

/* eslint-disable react/prefer-stateless-function */
export class Form extends React.Component {
  constructor(props) {
    super(props);

    let form = this.emptyForm();

    _.forEach(this.props.fields, field => (form[field.name].value = field.value || ''));

    this.state = {
      form,
    };
  }

  result() {
    let result = {};
    _.forEach(this.state.form, f => (result[f.name] = f.value));
    return result;
  }

  emptyForm() {
    let form = {};
    this.props.fields.forEach(field => (form[field.name] = { ...field, value: '' }));
    return form;
  }

  reset() {
    this.setState({ ...this.state, form: this.emptyForm() });
  }

  onInputChange(evt) {
    let state = this.state;
    state.form[evt.target.name].value = evt.target.value;
    this.setState(state);
  }

  render() {
    return _.map(this.state.form, formItem => {
      return (
        <FormField key={formItem.name} label={formItem.label || `lbl_form_${formItem.name}`}>
          {formItem.type == 'currency' ? '€' : ''}
          <Input
            id={formItem.name}
            type={formItem.name}
            name={formItem.name}
            placeholder={formItem.placeholder ? `lbl_placeholder_${formItem.placeholder}` : ``}
            value={this.state.form[formItem.name].value}
            data-lpignore="true"
            autocomplete="off"
            onChange={this.onInputChange.bind(this)}
          />
        </FormField>
      );
    });
  }
}

Form.propTypes = {
  fields: PropTypes.array.isRequired,
};

export function FromError(props) {
  return <div className="error">{props.children}</div>;
}

export function FormComplete(props) {
  let back = props.onBack ? <Button onClick={props.onBack}>lbl_btn_back</Button> : '';

  return (
    <div className="success">
      <div className="message">{props.message}</div>
      {back}
    </div>
  );
}
